import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { required, getNumericValidator } from '../../../Forms/fieldValidators'
import { FORM_CUPO } from '../../../../config/forms'
import { EntityAutocomplete, TipoCupoDropdown, CerealDropdown } from '../../../Forms/SharedComponents/containers'
import { Col } from 'react-bootstrap'
import { Grid, Button, FormControlLabel } from '@material-ui/core'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import Switch from '@material-ui/core/Switch'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import ListItemText from '@material-ui/core/ListItemText'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import Chip from '@material-ui/core/Chip'
import {
  TABLA_CUPOS_A_ASIGNAR
} from '../../../../config/tables'

const selector = formValueSelector(FORM_CUPO)
const numeric0to100 = getNumericValidator(0, 100)
export class NewAsignacionDialogView extends Component {
  constructor (props) {
    super(props)
    this.actualizarFechas = this.actualizarFechas.bind(this)
    this.handleChangeExportador = this.handleChangeExportador.bind(this)
    this.state = {
      showExportador: true,
      notificarPorCorreo: true,
      enviarATodos: true,
      personName: []
    }
  }

  componentDidMount () {
    const {
      actualizarMuiTable
    } = this.props
    actualizarMuiTable()
  }

  handleChangeExportador () {
    const {
      actualizarExportador,
      exportadorSeleccionado
    } = this.props

    actualizarExportador()
    if (exportadorSeleccionado) this.setState({ showExportador: !this.state.showExportador })
  }

  actualizarFechas (fechaD, fechaH) {
    const { change: formChange } = this.props
    formChange('fechaD', fechaD)
    formChange('fechaH', fechaH)
  }

  render () {
    const {
      submitCache,
      exportadorSeleccionado,
      handleCorreoUpdate,
      correosSeleccionados
    } = this.props
    const {
      showExportador,
      notificarPorCorreo,
      enviarATodos,
      personName
    } = this.state

    const handleNotificarPorCorreo = () => {
      const {
        change: formChange,
        updateNotificarPorCorreo
      } = this.props
      updateNotificarPorCorreo(!this.state.notificarPorCorreo)
      formChange('notificarPorCorreo', !this.state.notificarPorCorreo)
      this.setState({ notificarPorCorreo: !this.state.notificarPorCorreo })
      if (enviarATodos !== false || (!notificarPorCorreo && !enviarATodos)) handleEnviarATodos()
    }

    const handleEnviarATodos = () => {
      const {
        change: formChange,
        updateEnviarATodos
      } = this.props
      updateEnviarATodos(!this.state.enviarATodos)
      formChange('enviarATodos', !this.state.enviarATodos)
      this.setState({ enviarATodos: !this.state.enviarATodos })
    }

    const handleChange = (event) => {
      const {
        change: formChange,
        updateListaContactos
      } = this.props
      this.setState({ personName: event.target.value })
      formChange('contactosSeleccionados', event.target.value)
      updateListaContactos(event.target.value)
      console.log('valor', event.target.value)
      console.log('persona', personName)
    }

    const ITEM_HEIGHT = 48
    const ITEM_PADDING_TOP = 8

    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 350
        }
      }
    }

    return (
      <div>
        {!exportadorSeleccionado &&
          <Grid container justify='justify-start' alignItems='center'>
            <Col md={8}>
              <EntityAutocomplete
                name='exportador'
                label='Destinatario'
                entity='exportador'
                placeholder='Exportador - 19999999991'
                value={''}
              />
            </Col>
            <Col md={4}>
              <Button
                onClick={this.handleChangeExportador}
                type='button'
                size='medium'
                variant='contained'
                color='primary'
                disabled={!showExportador}
              >Seleccionar
              </Button>
            </Col>
          </Grid>}
        {exportadorSeleccionado &&
          <>
            <h3 className='info-exportador'>{exportadorSeleccionado}</h3>
            <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
              color='primary'
              name='notificarPorCorreo'
              onChange={handleNotificarPorCorreo}
              checked={notificarPorCorreo}
            />}label='Notificar por Correo Electrónico' />
            <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
              color='primary'
              name='enviarATodos'
              onChange={handleEnviarATodos}
              checked={enviarATodos}
              disabled={!notificarPorCorreo}
            />}label='Enviar a todos los contactos' />
            <Button style={{ marginLeft: '2%' }}
              onClick={handleCorreoUpdate}
              type='button'
              size='medium'
              variant='contained'
              color='primary'
              disabled={!notificarPorCorreo}
            >Administrar contactos
            </Button>
            {!enviarATodos &&
              <FormControl style={{ marginLeft: '3%', minWidth: 250, maxWidth: 400 }} >
                <InputLabel id='seleccion-label'>Seleccionar contactos</InputLabel>
                <Select
                  labelId='seleccion-label'
                  id='contactosSeleccionados'
                  multiple
                  value={personName}
                  onChange={handleChange}
                  input={<Input />}
                  renderValue={
                    (selected) => selected.map((correo) =>
                      <Chip
                        display='flex'
                        flexwrap='wrap'
                        color='primary'
                        variant='outlined'
                        key={correo.id}
                        label={correo.nombre}
                      />
                    )}
                  MenuProps={MenuProps}
                >
                  {correosSeleccionados.map((name) => (
                    <MenuItem key={name.id} value={name}>
                      <Checkbox checked={personName.indexOf(name) > -1} />
                      <ListItemText primary={name.nombre} secondary={name.correoElectronico} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>}
            <hr />
          </>}
        <Grid container justify='space-around'>
          <Col md={4}>
            <DatePicker
              style={{ width: '95%' }}
              disabledPast
              selectRange
              locale='es'
              // fechaHasta={fechaH}
              onDateChange={this.actualizarFechas}
              titulo='Fechas de Cupo (Desde - Hasta)'
            />
          </Col>

          <Col md={3}>
            <TipoCupoDropdown />
          </Col>

          <Col md={3}>
            <CerealDropdown />
          </Col>

          <Col md={2}>
            <Field
              name='cantidad'
              label='Cantidad'
              type='number'
              component={renderTextField}
              validate={[required, numeric0to100]}
              placeholder=''
            />
          </Col>
          <hr />
          <Button
            onClick={submitCache}
            type='button'
            size='medium'
            variant='contained'
            color='primary'
            disabled={!exportadorSeleccionado}
          >Agregar
          </Button>
        </Grid>
        <MuiTable id={TABLA_CUPOS_A_ASIGNAR} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  fechaDeCupo: selector(state, 'fechaDeCupo'),
  fechaD: selector(state, 'fechaD'),
  fechaH: selector(state, 'fechaH'),
  exportador: selector(state, 'exportador'),
  contactosSeleccionados: selector(state, 'contactosSeleccionados')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_CUPO,
  enableReinitialize: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(NewAsignacionDialogView))
